@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as m;
@use "styles/abstracts/mixins/typography" as t;

.wrapper {
  padding: 16px 24px 50px 24px;
  background-color: v.$palette-white;
  border-radius: 16px;
  box-shadow: v.$shadow2;
}

.actions {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 16px;

  @include m.media(v.$container-tablet) {
    flex-direction: column;
    align-items: stretch;
  }

  .btn {
    background-color: v.$palette-orange-2;

    &:hover {
      background-color: v.$palette-orange-3;
    }

    flex-shrink: 0;

    @include m.media(v.$container-tablet) {
      width: 100%;
      height: 58px;
      padding: 10px 16px;
      @include t.text(16px, 26px, 600);
    }
  }

  .pallets {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 8px 16px;
  }

  .toggle {
    margin-right: 0;
  }

  .infoCircle {
    cursor: pointer;
    flex-shrink: 0;

    path {
      transition: v.$transition;
    }

    @media (pointer: fine) {
      &:hover {
        path {
          fill: v.$palette-orange-2;
        }
      }
    }
  }
}

.tooltipContent {
  width: 348px;

  @include m.media(v.$container-tablet) {
    width: min(348px, calc(100vw - 48px));
  }
}
